export type UnauthorizedAction =
  /** No identity session: sign in again. */
  | "sign-in"
  /** The token was rejected: fetch a fresh one and resend once. */
  | "retry"
  /** The API rejected a fresh token too: stop calling it and show the error. */
  | "reject-session"
  /** The token was accepted; the 401 is a permission or license answer. */
  | "license-check"

export function unauthorizedAction(response: { sentToken: boolean; rejectedToken: boolean; retried: boolean }): UnauthorizedAction {
  if (!response.sentToken) {
    return "sign-in"
  }
  if (!response.rejectedToken) {
    return "license-check"
  }
  return response.retried ? "reject-session" : "retry"
}

/**
 * What to do with the token a forced refresh returned. When identity is
 * unreachable the session keeps the old token, so a resend would only prove
 * the outage, not that the API rejects new tokens. A token equal to the one
 * sent is still new: identity tokens carry no jti, so two issued in the same
 * second are identical.
 */
export function freshTokenOutcome(fresh: string | null, identityUnreachable: boolean): "sign-in" | "resend" | "give-up" {
  if (identityUnreachable) {
    return "give-up"
  }
  return fresh ? "resend" : "sign-in"
}
